import axios from 'axios';
import { HTTP_CONFIG } from '@/config/config.js'

//const API_BASE_URL = HTTP_CONFIG.API_BASE_URL; 
const API_BASE_URL = HTTP_CONFIG.API_laundry_URL; 
import laundryRequest from '@/utils/laundryRequest';

// const headers={
//       'USERNAME': "test_super_admin_account",
//       'TIMESTAMP': 1770773610,
//       'TOKEN': "325731abd79d661866b05c08628ca809"
//     };

// const headersStr=localStorage.getItem('headers');
// const headers=JSON.parse(headersStr);

//（0）登录接口
export const login = (data) => {
  return axios.post(`${API_BASE_URL}api/v1/auth/login/`, data);
};

//（1）统计分析模块
//1.1 获取概览统计卡片
// export const getOverviewStats = (params) => {
//   return axios.get(`${API_BASE_URL}smartwash/web/dashboard/getOverviewStats`, { params });
// };
export const getOverviewStats = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getOverviewStats`, { 
    params,
   });
};

//1.2 设备使用统计
export const getDeviceUsageStats = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getDeviceUsageStats`, { 
    params,
   });
};

//1.3 洗衣程序分布
export const getWashProgramDistribution = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getWashProgramDistribution`, { 
    params,
   });
}
//1.4 投诉类型统计
export const getComplaintStats = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getComplaintStats`, { 
    params,
  });
};

//1.5 订单时间分布
export const getOrderTimeDistribution = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getOrderTimeDistribution`, { 
    params,
});
};

//1.6 用户行为分析
export const getUserBehaviorAnalysis = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getUserBehaviorAnalysis`, { 
    params, 
});
};

//1.7 订单取消原因分析
export const getOrderCancelReasonAnalysis = (params) => {
  return laundryRequest.get(`smartwash/web/dashboard/getOrderCancelReasonAnalysis`, { 
    params,
 });
};

//1.8 导出图表数据
export const exportChartData = (data) => {
  return laundryRequest.post(`smartwash/web/dashboard/exportChartData`, data);
};

//（2）订单管理
//查询全部订单
export const listOrders = (params) => {
  return laundryRequest.get(`/smartwash/web/orderManage/listOrders`, { params });
};

//（3）设备管理
// 第一部分：设备信息页
// 3.1 查询设备信息
export const listDevices = (params) => {
  return laundryRequest.get(`smartwash/web/deviceManage/listDevices`, { params });
};

// 3.2（编辑回显）
export const getDeviceDetail = (deviceId) => {
  return laundryRequest.get(`smartwash/web/deviceManage/getDeviceDetail`, { params: { deviceId } });
};

// 3.3添加设备信息
export const addDevice = (data) => {
  return laundryRequest.post(`smartwash/web/deviceManage/addDevice`, data);
};

// 3.4编辑保存并更新设备信息
export const updateDevice = (data) => {
  return laundryRequest.post(`smartwash/web/deviceManage/updateDevice`, data);
};

// 3.5删除设备信息
export const deleteDevice = (data) => {
  return laundryRequest.post(`smartwash/web/deviceManage/deleteDevice`, data);
};

// 3.5查询设备状态
export const getDeviceRunningStatus = (params) => {
  return laundryRequest.get(`/smartwash/web/deviceManage/getDeviceRunningStatus`, { params });
};

// 第二部分：设备故障统计
// 3.7查询设备故障记录
export const listDeviceFaults = (params) => {
  return laundryRequest.get(`smartwash/web/deviceManage/listDeviceFaults`, { params });
};

// 3.8编辑统计故障:将故障状态更新为“处理中/已处理”
export const handleDeviceFault = (data) => {
  return laundryRequest.post(`smartwash/web/deviceManage/handleDeviceFault`, data);
};

// 第三部分：使用统计页（设备管理 > 使用统计）
// 3.6导出报表
export const getDeviceUsageReport = (deviceIds) => {
  return laundryRequest.get(`smartwash/web/deviceManage/getDeviceUsageReport`, { params: { deviceIds } });
};
// 3.9导出使用统计或故障报表
export const exportDeviceReport = (data) => {
  return laundryRequest.post(`smartwash/web/deviceManage/exportDeviceReport`, data);
};

//（4）消息推送
//删除推送记录
export const deletePushRecord = (data) => {
  return laundryRequest.post(`laundry/delete_push_record`, data);
};

//查询推送记录
export const queryPushRecord = (params) => {
  return laundryRequest.get(`laundry/query_push_record`, { params });
};

//查询超时通知
export const queryTimeoutNotice = (params) => {
  return laundryRequest.get(`laundry/query_timeout_notice`, { params });
};

//（5）投诉处理

//5.1 提交投诉
export const submitComplaint = (data) => {
    return laundryRequest.post(`/smartwash/web/complaintManage/submitComplaint`, data);
};

//5.2 审核投诉
export const reviewComplaint = (data) => {
    return laundryRequest.post(`/smartwash/web/complaintManage/reviewComplaint`, data);
};

//5.3 投诉列表
export const listComplaints = (params) => {
    return laundryRequest.get(`/smartwash/web/complaintManage/listComplaints`, { params });
};

//投诉统计
export const getStatistics = (params) => {
    return laundryRequest.get(`/smartwash/web/complaintManage/getStatistics`, { params });
};

//5.4 通知列表
export const listNotifications = (params) => {
    return laundryRequest.get(`/smartwash/web/notificationManage/listNotifications`, { params });
};

//5.5 标记通知已读
export const markAsRead = (data) => {
    return laundryRequest.post(`/smartwash/web/notificationManage/markAsRead`, data);
};

//5.6 获取用户状态
export const getUserStatus = (params) => {
    return laundryRequest.get(`/smartwash/web/userManage/getUserStatus`, { params });
};

//（6）用户管理
// 第一部分：用户名单
// 6.1 用户管理列表
export const listUsers = (params) => {
    return laundryRequest.get(`smartwash/web/userManage/listUsers`, { params });
};

// 6.2 编辑回显（用户管理 > 用户名单 > 编辑）
// （员工姓名/微信号/宿舍号/用户状态/所属公司/联系电话）
export const getUserDetail = (params) => {
    return laundryRequest.get(`smartwash/web/userManage/getUserDetail`, { params });
};

//6.3 新增用户(用户管理 > 用户名单 > 新增  )
//（提交员工姓名/微信号/宿舍号/所属公司/联系电话/用户状态）
export const createUser = (data) => {
    return laundryRequest.post(`smartwash/web/userManage/createUser`, data);
};

//6.4 编辑用户(用户管理 > 用户名单 > 编辑  )
export const updateUser = (data) => {
    return laundryRequest.post(`smartwash/web/userManage/updateUser`, data);
};

//6.5 删除用户(用户管理 > 用户名单 > 删除  )
export const deleteUser = (data) => {
    return laundryRequest.post(`smartwash/web/userManage/deleteUser`, data);
};

//6.6 禁用用户（用户管理 > 用户名单（用户状态置为“禁用”） ）
export const banUser = (data) => {
    return laundryRequest.post(`smartwash/web/userManage/banUser`, data);
};

//6.7 启用用户（用户管理 > 用户名单（用户状态置为“启用”） ）
export const unbanUser = (data) => {
    return laundryRequest.post(`smartwash/web/userManage/unbanUser`, data);
};

//6.8 批量导入用户（Excel）- 接收data和axios配置参数，使用config
export const importUsers = (data, config) => {
  return laundryRequest.post(`smartwash/web/api/users/bulk-import/`, data, config);
};  

//6.9 下载用户导入模板 - 接收axios配置参数,使用config（解决params未使用）
export const downloadUserTemplate = (config) => {
  return laundryRequest.get(`smartwash/web/api/users/import-template/`, config);
};

//6.10 导出用户数据(20260408新增)
export const exportUsers = (data) => {
    return laundryRequest.post(`smartwash/web/reportManage/exportUserList`, data);
};

//6.11 用户行为日志
export const getUserBehaviorLogs = (params) => {
  return laundryRequest.get(`smartwash/web/userManage/getUserBehaviorLogs`, { params });
};

//6.12 黑名单列表
export const listBlacklistUsers = (params) => {
  return laundryRequest.get(`smartwash/web/userManage/listBlacklistUsers`, { params });
};

// 6.13 加入黑名单
export const addToBlacklist = (data) => {
  return laundryRequest.post(`smartwash/web/userManage/addToBlacklist`, data);
};

// 6.14 移出黑名单
export const removeFromBlacklist = (data) => {
  return laundryRequest.post(`smartwash/web/userManage/removeFromBlacklist`, data);
};

//（7）权限管理
// 权限管理-角色管理
// 7.1查询用户角色
export const listRoles = (params) => {
    return laundryRequest.get(`smartwash/web/permissionManage/listRoles`, { params });
};
// 7.2编辑用户权限
export const updateUserRole = (data) => {
    return laundryRequest.post(`smartwash/web/permissionManage/updateUserRole`, data);
};

// 权限管理-操作日志
// 7.3查询用户操作日志
export const listOperationLogs = (params) => {
    return laundryRequest.get(`smartwash/web/permissionManage/listOperationLogs`, { params });
};
// 7.4导出操作日志
export const exportOperationLog = (data) => {
    return laundryRequest.post(`smartwash/web/permissionManage/exportOperationLogs`, data);
};

// 权限管理-权限变更记录
// 7.5查询用户权限变更记录
export const listPermissionChangeLogs = (params) => {
    return laundryRequest.get(`smartwash/web/permissionManage/listPermissionChangeLogs`, { params });
};

//(8)报表管理
//设备使用周报/月报
export const getDeviceUsageReportAll = (params) => {
    return laundryRequest.get(`smartwash/web/reportManage/getDeviceUsageReport`, { params });
};

//用户行为周报/月报
export const getUserBehaviorReport = (params) => {
    return laundryRequest.get(`smartwash/web/reportManage/getUserBehaviorReport`, { params });
};

//订单分析周报/月报
export const getOrderAnalysisReport = (params) => {
    return laundryRequest.get(`smartwash/web/reportManage/getOrderAnalysisReport`, { params });
};

//投诉分析周报/月报
export const getComplaintAnalysisReport = (params) => {
    return laundryRequest.get(`smartwash/web/reportManage/getComplaintAnalysisReport`, { params });
};

//导出综合报表
export const exportReport = (data) => {
    return laundryRequest.post(`smartwash/web/reportManage/exportReport`, data);
};

